import { formatConstraints } from './formatConstraints';
import { getConstraintsForProperty } from './getConstraintsForProperty';
import { localizeConstraint } from '../i18n/errors';
import { portalLanguage } from '../i18n';

export const getFieldErrors = (errors: any[], properties: string[]): any => {
  const formattedConstraints = formatConstraints(
    getConstraintsForProperty(errors, properties),
  );
  if (!formattedConstraints) return '';
  if (portalLanguage() === 'en') {
    return formattedConstraints.join(' ').trim();
  }
  // The server's class-validator messages are English; in FR/ES each one is
  // replaced by its translation (i18n/errors.ts), said once.
  return formattedConstraints
    .map((m) => (typeof m === 'string' ? localizeConstraint(m) : m))
    .filter((m, i, all) => all.indexOf(m) === i)
    .join(' ')
    .trim();
};
